import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

type RequestBody = string[];

const ProductSchema = z.object({
	priority: z.number(),
	productId: z.string(),
	sourceId: z.string(),
});

const OrderGuideSchema = z.object({
	id: z.string(),
	ingredientId: z.string(),
	products: z.array(ProductSchema),
});

export type OrderGuide = z.infer<typeof OrderGuideSchema>;

const ResponseDataSchema = z.array(OrderGuideSchema);
const validator = createValidator(ResponseDataSchema);

export type ResponseData = z.infer<typeof ResponseDataSchema>;
export type Product = z.infer<typeof ProductSchema>;

export async function callApi(request: RequestBody): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/erp/order-guide`;
	return (await axios.post(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
